import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import styles from './BoxWithVideo.module.scss';
import ReactPlayer from 'react-player';
import { addCustomPathToLink, generateKey, sanitizeType } from '../../functions';
import SwiperCustom from '../SwiperCustom/SwiperCustom';
import { Swiper, SwiperSlide } from 'swiper/react';
import Lottie from 'lottie-react';
import { DataContext } from '../../views/pages/Root';
import { Navigation, Scrollbar } from 'swiper';

const BoxWithVideo = ({ api, type }) => {
  const [animation, setAnimation] = useState();
  const [date, setDate] = useState();
  const data = useContext(DataContext);
  const { event_start, event_end } = api.attributes;
  useEffect((_) => {
    const currentDate = new Date().toISOString();
    setDate(currentDate);
  }, []);

  useEffect((_) => {
    if (!!api.attributes.animationName) {
      setAnimation(!!data?.animations2?.length && data.animations2.find((prop) => prop.name == api.attributes.animationName));
    }
  }, []);

  const VideoItem = ({ video, slideIndex = null, isSliderItem = false }) => {
    const [playing, setPlaying] = useState(false);
    const [videoSrc, setVideoSrc] = useState(addCustomPathToLink(video.src, true));

    const handleResize = () => {
      if (window.innerWidth > 992) {
        const newSrc = addCustomPathToLink(video.src, true);
        if (videoSrc !== newSrc) {
          setVideoSrc(newSrc);
        }
      } else {
        const newSrc = addCustomPathToLink(video.srcmobile, true);
        if (videoSrc !== newSrc) {
          setVideoSrc(newSrc);
        }
      }
    };

    React.useEffect(() => {
      if (!!video.srcmobile) {
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }
    }, [video.srcmobile]);

    return (
      !!videoSrc && (
        <div className={`${styles.videoContent} ${!!video.btnScroll ? 'scrollDown' : ''}`}>
          <ReactPlayer
            key={videoSrc}
            url={videoSrc}
            className={`${styles.video} ${type === 'full' ? styles.fullVideo : ''}`}
            playing={type === 'full' ? true : playing}
            onClick={(_) => {
              if (type !== 'full') {
                setPlaying(false);
              }
            }}
            onPause={(_) => {
              if (type !== 'full') {
                setPlaying(false);
              }
            }}
            onEnded={(_) => {
              if (type !== 'full') {
                setPlaying(false);
              }
            }}
            onPlay={() => {
              if (type !== 'full') {
                setPlaying(true);
              }
            }}
            playsinline={true}
            loop={type === 'full'}
            controls={false}
            volume={(!!api?.attributes?.soundon && api.attributes.soundon === true) || isSliderItem ? 1 : 0}
            muted={!isSliderItem && (!api?.attributes?.soundon || api.attributes.soundon !== true)}
            width="100%"
            height="100%"
          />
          {!playing && (
            <>
              {!!video?.image && <img className={styles.videoImg} src={addCustomPathToLink(video.image, true)} alt={video.alt}></img>}
              {type !== 'full' && (
                <button
                  className={styles.btnPlay}
                  onClick={(_) => {
                    setPlaying(true);
                  }}
                ></button>
              )}
            </>
          )}
        </div>
      )
    );
  };

  const swiperButtonPrevRef = useRef(null);
  const swiperButtonNextRef = useRef(null);

  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
    // setIsPlayingSth(false)
    swiperButtonNextRef.current.classList.remove('swiper-button-disabled');
    sliderRef.current.swiper.activeIndex == 0
      ? swiperButtonPrevRef.current.classList.add('swiper-button-disabled')
      : swiperButtonPrevRef.current.classList.remove('swiper-button-disabled');
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
    // setIsPlayingSth(false)
    swiperButtonPrevRef.current.classList.remove('swiper-button-disabled');
    sliderRef.current.swiper.activeIndex == sliderRef.current.swiper.slides.length - 1
      ? swiperButtonNextRef.current.classList.add('swiper-button-disabled')
      : swiperButtonNextRef.current.classList.remove('swiper-button-disabled');
  }, []);

  if (!!api.attributes.event_start && !!api.attributes.event_end && (!date || api.attributes.event_start > date || date > api.attributes.event_end))
    return null;

  return (
    <section
      id={api?.id}
      className={`${styles.BoxWithVideo} ${!!type && (type == 'square' || type.includes('square')) ? styles.BoxWithVideoRow : ''}  ${
        !!type && (type == 'rolls' || type.includes('rolls')) ? styles.BoxWithRolls : ''
      } ${!!api.attributes?.title && styles.paddingCorner}`}
      data-aos="fade-up"
      // data-aos-delay="300"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
      // data-aos-anchor-placement="top-center"
    >
      {type != 'full' && (!!api.attributes?.title || !!api.attributes?.description) && (
        <div
          className={styles.textContent}
          data-aos="fade-up"
          // data-aos-delay="300"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
          // data-aos-anchor-placement="top-center"
        >
          {!!animation && (
            <figure className={styles.backgroundContainer}>
              {!!animation && <Lottie autoplay="true" animationData={animation?.value} loop={true} className={styles.animationOnImage}></Lottie>}
            </figure>
          )}
          {!!api.attributes?.title && <h2 className={styles.title}>{api.attributes.title}</h2>}
          {!!api.attributes?.description && <p className={styles.description}>{api.attributes.description}</p>}
        </div>
      )}
      {!!api?.attributes?.video && <VideoItem video={api.attributes.video} />}
      {!!api?.attributes?.videos && (
        <div className={styles.swiperContainer}>
          <Swiper
            ref={sliderRef}
            data-aos="zoom-in"
            data-aos-duration="1000"
            data-aos-easing="easy-in-out"
            scrollbar={{
              el: '.swiper-scrollbar',
              hide: false,
              draggable: true,
              dragClass: 'swiper-scrollbar-drag',
            }}
            slidesPerView={1}
            spaceBetween={16}
            className={`${styles.swiperCards} ${styles.swiper} ${sanitizeType(type, styles)}`}
            breakpoints={{
              992: {
                allowTouchMove: false,
              },
            }}
          >
            {api.attributes.videos.map((video, index) => (
              <SwiperSlide className={`${styles.SwiperSlide}`} key={generateKey()}>
                <VideoItem video={video} slideIndex={index} isSliderItem={true} />
              </SwiperSlide>
            ))}
          </Swiper>
          {api.attributes.videos.length > 1 && (
            <>
              <div
                ref={swiperButtonPrevRef}
                className={styles.swiperButtonPrev + ' swiper-button-prev swiper-button-disabled'}
                onClick={handlePrev}
              ></div>
              <div ref={swiperButtonNextRef} className={styles.swiperButtonNext + ' swiper-button-next'} onClick={handleNext}></div>
            </>
          )}
        </div>
      )}
    </section>
  );
};
export default BoxWithVideo;
